import React from 'react';
import logoIcon from '../../images/datto-small-icon.svg';

const DattoSmallLogo = (props) => {
    return <span dangerouslySetInnerHTML={{ __html: logoIcon }} {...props} />;
};

export default DattoSmallLogo;
